import { PasswordRecoveryModule } from './password-recovery/password-recovery.module';
import { NgModule } from "@angular/core";
import { LoginModule } from "./login/login.module";
import { DashModule } from "./dash/dash.module";
import { AuthCallbackModule } from "./auth-callback/auth-callback.module";
import { ParticipantesModule } from './participantes/participantes.module';
import { ClientesModule } from './clientes/clientes.module';
import { ImportacoesModule } from './importacoes/importacoes.module';
import { CargaInicialModule } from './carga-inicial/carga-inicial.module';
import { MovimentacaoModule } from './movimentacao/movimentacao.module';
import { OrdemProducaoModule } from './ordem-producao/ordem-producao.module';
import { OrdemProducaoOutrosEstabModule } from './ordem-producao-outros-estab/ordem-producao-outros-estab.module';
import { ProdutosModule } from './produtos/produtos.module';
import { EnquadramentoLegalModule } from './enquadramento-legal/enquadramento-legal.module';
import { CfopsModule } from './cfops/cfops.module';
import { AjusteEstoqueModule } from './ajuste-estoque/ajuste-estoque.module';
import { InventarioModule } from './inventario/inventario.module';
import { EstornosModule } from './estornos/estornos.module';
import { TransferenciaFichasModule } from './transferencia-fichas/transferencia-fichas.module';
import { CfopsDevolucaoModule } from './cfops-devolucao/cfops-devolucao.module';
import { DevolucaoModule } from './devolucao/devolucao.module';

import { DespachosModule } from './despachos/despachos.module';

import { CodigosInternosModule } from './codigos-internos/codigos-internos.module';

import { CodigoLancamentoModule } from './codigo-lancamento/codigo-lancamento.module';
import { RateioEnergiaModule } from './rateio-energia/rateio-energia.module';
import { MascarasModule } from './mascaras/mascaras.module';
import { ProcessamentoFichasModule } from './processamento-fichas/processamento-fichas.module';
import { ProcessamentoFichasNovoModule } from './processamento-fichas/novo/novo.module';
import { ComparacaoArquivosModule } from './comparacao-arquivos/comparacao-arquivos.module';
import { ProcessosModule } from './processos/processos.module';
import { UserModule } from './user/user.module';

@NgModule({
  declarations: [
  ],
  imports: [
    LoginModule,
    DashModule,
    AuthCallbackModule,
    PasswordRecoveryModule,
    ParticipantesModule,
    ClientesModule,
    MascarasModule,
    ProdutosModule,
    EnquadramentoLegalModule,
    OrdemProducaoModule,
    OrdemProducaoOutrosEstabModule,
    CargaInicialModule,
    MovimentacaoModule,
    CfopsModule,
    AjusteEstoqueModule,
    InventarioModule,
    EstornosModule,
    TransferenciaFichasModule,
    CfopsDevolucaoModule,
    DevolucaoModule,
    DespachosModule,
    RateioEnergiaModule,
    CodigosInternosModule,
    CodigoLancamentoModule,
    ProcessamentoFichasModule,
    ProcessamentoFichasNovoModule,
    ComparacaoArquivosModule,
    ProcessosModule,
    UserModule
  ],
  exports: [

  ]
})
export class HomeModule { }
